import { useState } from "react"
import { useLocation, useNavigate } from "react-router-dom";
import { joinGame } from "../tools/GameTools";
import "../styles/JoinGame.css"

export const JoinGame = () => {
    const [message, setMessage] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();
    joinGame(location.pathname.substring(location.pathname.lastIndexOf("/") + 1)).then(data => {
        if (data.error) {
            setMessage(data.error);
        } else {
            window.location.href = "/game/" + location.pathname.substring(location.pathname.lastIndexOf("/") + 1)
        }
    }).catch(e => {
        navigate("/?gameToJoin=" + location.pathname.substring(location.pathname.lastIndexOf("/") + 1))
    })

    const backToHome = () => {
        navigate("/");
    }
    return <div className="join-game-container">
        <p>
            {message || "Joining game"}
        </p>
        {message && <button className="btn-join-game-back-to-home" onClick={backToHome}>Back to Home</button>}
    </div>
}